import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const StorageCapacity = ({ onStorageCapacitySelected }) => {
  const [selectedStorageCapacity, setSelectedStorageCapacity] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.storagecapacity) {
        const storageCapacityObject = firstResult.storagecapacity;
        if (storageCapacityObject.trim() !== "") {
          setVariations(storageCapacityObject.split(","));
        }
      }
    } catch (error) {
      console.error("Error fetching product variations:", error);
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleStorageCapacityClick = (storagecapacity) => {
    setSelectedStorageCapacity(storagecapacity);
    onStorageCapacitySelected(storagecapacity);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Storage Capacity:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedStorageCapacity === variation ? "selected" : ""}`}
            onClick={() => handleStorageCapacityClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default StorageCapacity;
